module.exports = __webpack_public_path__ + "static/media/m1.ba67d5b4.jpg";